import { countLabel, pageLabel, positive } from '../armKit';
import { cardPartCss, hideViewCountCss } from '../surface';

import type { ArmSpec } from '../armRegistry';

const FLAG = 'cardfacts';
const CHIP =
  'background: #0954d3; border-radius: 100px; padding: 2px 8px; color: #fff;';

export const cardFacts: ArmSpec = {
  onCards: (cards, ctx) => {
    void ctx.workFacts().then((facts) => {
      const pending = cards.flatMap((card) => {
        if (card.flag(FLAG) != null) return [];

        const fact = facts.get(card.workId);
        // A zero is a real answer here and still must not render: telling a
        // visitor nobody has read this paper argues against the click.
        const views = countLabel(positive(fact?.views), 'view');
        const labels = [pageLabel(fact?.pageCount), views].filter(
          (label): label is string => label != null,
        );

        return labels.length === 0
          ? []
          : [{ card, labels, hasViews: views != null }];
      });

      if (pending.length === 0) return;

      const flags = pending.map(({ card, labels, hasViews }) => {
        const flagged = card.setFlag(FLAG, hasViews ? 'views' : 'facts');
        labels.forEach((label) => card.addChip(label));

        return hasViews ? flagged : null;
      });
      const viewsFlag = flags.find((flag) => flag != null);

      ctx.injectStyles(
        cardPartCss('chip', ctx.scope, CHIP) +
          (viewsFlag == null
            ? ''
            : hideViewCountCss(`${ctx.scope} ${viewsFlag}`)),
      );
    });
  },
};
